import React from 'react';
import { Divider } from 'rsuite';
import { Row } from './row';

export const DividerRow = ({ colspan }) => (
  <Row>
    <td colSpan={colspan}>
      <Divider />
    </td>
  </Row>
);
